var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['shelf', _vm.indexList == 0 ? 'shelf-top' : 'shelf-other']},_vm._l((_vm.bookList),function(book,index){return _c('div',{key:index,class:[
      'book-shelf',
      _vm.indexList == 0 ? 'book-shelf-top' : 'book-shelf-other'
    ]},[_c('img',{class:_vm.indexList == 0 ? 'book-img-top' : 'book-img-other',attrs:{"src":book.imageUrl},on:{"click":function($event){return _vm.handleChildClick(book.category)}}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d584bb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fanClub/leaders/LeadersBook.vue
// module id = null
// module chunks = 